export default __webpack_public_path__ + "static/WDRMODE_1_WDR_STRENGTH_3-d3e12f11fb0f598ef8ae871b470d6cf7.avif";